import React from "react";
import styles from "./Error.module.css";
import { Link } from "react-router-dom";
import { LOGIN_PATH } from "../../router/RouteConstants";
import { useAuthenticate } from "../../hooks";
import { useIntl } from "react-intl";

const ErrorPageNotFound = () => {
    const { auth } = useAuthenticate();
    const intl = useIntl();
    const { formatMessage: f } = intl;

    return (
        <div className={styles.error_not_found}>
            <div>404</div>
            <div>{f({ id: 'AI_EDU_PAGE_NOT_FOUND' })}</div>
            <Link className={styles.link_to_home} to={LOGIN_PATH}>
                {auth ? f({ id: 'AI_EDU_GO_TO_DASHBOARD_PAGE' }) : f({ id: 'AI_EDU_GO_TO_LOGIN_PAGE' })}
            </Link>
        </div>
    );
};

export default ErrorPageNotFound;
